import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import Th from "@/components/Table/Th";
import { table_head } from "../orders_delivery_constants";
import { textConstants } from "@/languages/textConstants";

const OrdersDeliveryTableHead = ({ base, setBase }) => {
	let location = useLocation();
	const { customer } = useSelector((state) => state.auth.user);

	const setAllOrder = (order, orderType) => {
		setBase({ ...base, order: order, orderType: orderType });
	};

	const newHead = table_head
		.filter((item) => {
			if (location.pathname.includes("sin_documento")) {
				return !["dealer_name", "delivery_number", "date_orders_delivery"].includes(item.order) && !["Facturas Asociadas"].includes(item.name);
			}
			if (location.pathname.includes("guias_despacho")) {
				return !["origin_type"].includes(item.order);
			}
			return true;
		})
		.map((item) => {
			if (item.name === "delivery_text_numero") {
				item.name = textConstants[customer.country_id].delivery;
			}
			return item;
		});

	return (
		<thead>
			<tr>
				{newHead &&
					newHead.map((item, i) => {
						return (
							<Th
								key={i}
								item_name={item.name}
								item_size={item.size}
								item_order={item.order}
								order={base.order}
								setOrder={null}
								orderType={base.orderType}
								setOrderType={null}
								item_class={item.class}
								item_check_permission={item.check_permission}
								setAllOrder={setAllOrder}
							/>
						);
					})}
			</tr>
		</thead>
	);
};

export default OrdersDeliveryTableHead;
